import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { IServerOperationMethod, ServerOperationMethodItem } from "../OperationMethodItem";

class BaseServerOperationHandler {
    private collection: ServerOperationMethodItem[];
    private actionReference: BaseAction;

    constructor(action: BaseAction) {
        this.collection = [];
        this.actionReference = action;
    }
    /**
     * Register non global operation that will be mapped to specified function. Mapping will occur with reference to RegisteredOperation and MessageId
     * @param operation Local.LocalRegisteredOperation that will invoke this function
     * @param fn Callback function that will be invoked. This function will receive (request: LocalEvent, store: BaseStore arguments)
     * @param autoemit True by default. If set to false, function will not emit change to listeners automatically
     */
    public RegisterOperation(operation: number, fn: IServerOperationMethod, suboperation?: number, autoemit?: boolean): void {
        if (suboperation == null) suboperation = 0;
        var emit = autoemit == null ? true : autoemit;
        var item = ServerOperationMethodItem.Create(operation, suboperation, fn, emit); item.isGlobal = false;
        this.collection.push(item);
    }

    /**
     * Register global operation
     * @param operation Local.LocalRegisteredOperation that will invoke this function
     * @param fn Callback function that will be invoked. This function will receive (request: LocalEvent, store: BaseStore arguments)
     * @param suboperation sub-operation used to map multiple functions to the SAME Server Registered Operation
     * @param autoemit True by default. If set to false, function will not emit change to listeners automatically
     */
    public RegisterGlobalOperation(operation: number, fn: IServerOperationMethod, suboperation?: number, autoemit?: boolean): void {
        if (suboperation == null) suboperation = 0;
        var emit = autoemit == null ? true : autoemit;
        var item = ServerOperationMethodItem.Create(operation, suboperation, fn, emit); item.isGlobal = true;
        this.collection.push(item);
    }

    // review for errors
    public Invoke(instance: any, context: BaseStore, response: ServerEvent): void {
        for (let e of this.collection) {
            if (e.operation === response.Operation && e.suboperation === response.SubOperation) {
                if (e.isGlobal) {
                    e.method.apply(instance, [response, context]);
                    if (e.autoEmit) { context.EmitChangeToListeners(); }
                }
                else {
                    if (this.actionReference.ShouldHandleResonse(response)) {
                        this.actionReference.HandleResponseFor(response, () => {
                            e.method.apply(instance, [response, context]);
                            if (e.autoEmit) {
                                context.EmitChangeToListeners();
                            }
                        });
                    }
                }
            }
        }
    }
}

export { BaseServerOperationHandler };
